export const UFATLogoIcon = () => (
  <svg className="block h-full w-full" viewBox="0 0 160 160" aria-hidden="true" focusable="false">
    <path d="M20 24h30v66c0 20 11 32 30 32s30-12 30-32V24h30v67c0 38-24 65-60 65S20 129 20 91V24Z" fill="currentColor" />
    <path d="M48 24h82v28H78v28h43v27H78v49H48V24Z" fill="currentColor" opacity=".72" />
  </svg>
);
